import request from '@/utils/request';

/**
 * @name userLogin
 * @description 用户登录
 */
export const userLogin = function (data: User.Login.Request) {
    return request.http<User.Login.Response>({
        method: 'POST',
        url: '/user/login',
        data
    });
};
/**
 * @name userLogin
 * @description 用户登录
 */
export const getAppInfo = function (data: User.appInfo.Request) {
    return request.http<Record<string, unknown>>({
        method: 'POST',
        url: '/getAppInfo.json',
        data
    });
};

/**
 * @name userLogout
 * @description 用户登录
 */
export const userLogout = function (data: Record<string, unknown>) {
    return request.http<null>({
        method: 'POST',
        url: '/logout.json',
        data
    });
};

/**
 * @name userSendCode
 * @description 发送验证码
 */
export const userSendCode = function (data: User.SendCode.Request) {
    return request.http<null>({
        method: 'POST',
        url: '/sendLoginCode.json',
        data
    });
};

/**
 * @name userLoginByCode
 * @description 手机验证码登录
 */
export const userLoginByCode = function (data: User.LoginByCode.Request) {
    return request.http<User.LoginByCode.Response>({
        method: 'POST',
        url: '/login.json',
        data
    });
};

/**
 * @name getUserMenuList
 * @description 获取用户菜单授权列表
 */
export const getUserMenuList = function () {
    return request.http<{ home: string; menuList: Menu.IMenu[] }>({
        method: 'POST',
        url: '/chsBusinessUser/getUserMenuList.json'
    });
};

/**
 * @name getBusinessListByMobile
 * @description 获取绑定商家列表接口
 */
export const getBusinessListByMobile = function (data: { mobileNo: string }) {
    return request.http<Common.ListData<any>>({
        method: 'POST',
        url: '/getMyBusinessList.json',
        data
    });
};

/**
 * @name getShopList
 * @description 获取店铺列表
 */
export const getShopList = function () {
    return request.http<any[]>({
        method: 'POST',
        url: '/chsVenues/getShopList.json'
    });
};
